import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Moment from 'moment';
import SvgIcon from '@material-ui/core/SvgIcon';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Skeleton from '@material-ui/lab/Skeleton';

const styles = theme => ({
    tableContainer: {
        overflowY: 'auto',
        maxHeight: 'calc(100% - 2rem)',
    },
    table: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: '0 4px',
    },
    tableRow: {
        backgroundColor: theme.palette.background.paper,
        '&:nth-of-type(odd)': {
            backgroundColor: '#343a40',
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#343a40',
        },
        '& > *': {
            padding: '0.5rem',
            borderBottom: '2px solid #ff8c00',
        },
    },
    tableCell: {
        textAlign: 'center',
        color: 'white',
    },
    tableHeadCell: {
        textAlign: 'center',
        fontWeight: 'bold',
        color: '#fa7d34',
        backgroundColor: '#343a40',
        borderBottom: '1px solid #fa7d34',
        padding: '0.75rem',
    },
    cardmiddle: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
});

class DiaryJob extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jobs: props.jobs || [],
            aircrafData: props.aircraft || [],
            isLoading: true,
            jobTypeMap: {
                budgeted: this.props.res.PLANEJAMENTO,
                //planned: this.props.res.PLANEJADO,
                approved: this.props.res.APROVADO,
                running: this.props.res.TRABALHANDO,
                concluded: this.props.res.CONCLUIDO,
                canceled: this.props.res.CANCELADO,
            },
        };
    }

    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.jobs !== this.props.jobs || prevProps.aircraft !== this.props.aircraft) {
            this.update();
        }
    }

    update = () => {
        this.setState({
            jobs: this.props.jobs,
            aircrafData: this.props.aircraft,
            isLoading: false,
        });
    };

    getAircraftName = (id_plane) => {
        if (id_plane) {
            const aircraft = this.state.aircrafData.find((plane) => plane.id === id_plane);
            return aircraft ? aircraft.name : '-';
        }
        return 'Outros';
    };

    renderTable = () => {
        const { classes, res } = this.props;

        return (
            <div className={classes.tableContainer}>
                <Table className={classes.table} stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeadCell}>{res.TITULO}</TableCell>
                            <TableCell className={classes.tableHeadCell}>{res.STATUS}</TableCell>
                            <TableCell className={classes.tableHeadCell}>{res.AERONAVE}</TableCell>
                            <TableCell className={classes.tableHeadCell}>{res.AREA_PLANEJADA}</TableCell>
                            <TableCell className={classes.tableHeadCell}>{res.AREA_EXECUTADA}</TableCell>
                            <TableCell className={classes.tableHeadCell}>{res.STARTDATE_}</TableCell>
                            <TableCell className={classes.tableHeadCell}>{res.ENDDATE_}</TableCell>
                            <TableCell className={classes.tableHeadCell}>{res.ATUALIZADO}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.jobs.map(job => (
                            <TableRow key={job.id} className={classes.tableRow}>
                                <TableCell className={classes.tableCell}>{job.title}</TableCell>
                                <TableCell className={classes.tableCell}>{this.state.jobTypeMap[job.type]}</TableCell>
                                <TableCell className={classes.tableCell}>
                                    {job.list_exe && job.list_exe.length > 0 && job.list_exe[0].id_plane
                                        ? this.getAircraftName(job.list_exe[0].id_plane)
                                        : 'Outros'}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {job.list_exe && job.list_exe.length > 0
                                        ? `${job.list_exe[0].area_polygon} ha`
                                        : '-'}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {job.list_exe && job.list_exe.length > 0
                                        ? `${job.list_exe[0].area_spray} ha`
                                        : '-'}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {Moment(job.list_exe[0].startDate).format(res.FORMAT_DATAHORAMIN)}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {Moment(job.list_exe[0].endDate).format(res.FORMAT_DATAHORAMIN)}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {Moment(job.updated).format(res.FORMAT_DATAHORAMIN)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        );
    };

    render() {
        const { classes, res } = this.props;

        return (
            <div className='dashboard-card' style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div className='divContent'
                    style={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                        borderRadius: '.8rem',
                        backgroundColor: '#343a40',
                        overflow: 'hidden',
                        height: '100%',
                        width: '100%',
                        position: 'absolute',
                        flexGrow: 1
                    }}>
                    <div className='cardheader'>
                        <SvgIcon viewBox="0 96 960 960" style={{ width: '1.7rem', height: '1.7rem', color: '#fa7d34' }}>
                            <path d="M140 936q-24 0-42-18t-18-42V505h60v371h452v60H140Zm121-120q-24 0-42.5-18T200 756V385h60v371h453v60H261Zm119-120q-24 0-42-18t-18-42V276q0-24 18-42t42-18h440q24 0 42 18t18 42v360q0 24-18 42t-42 18H380Zm0-60h440V338H380v298Z" />
                        </SvgIcon>
                        <span className='title'>
                            {res.TRABALHOS}
                        </span>
                    </div>
                    <div className={classes.cardmiddle}>
                        {this.state.isLoading ? (
                            <Skeleton variant="rect" width="100%" height={200} />
                        ) : (
                            this.renderTable()
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

DiaryJob.propTypes = {
    classes: PropTypes.object.isRequired,
    jobs: PropTypes.array.isRequired,
    aircraft: PropTypes.array.isRequired,
};

export default withStyles(styles)(DiaryJob);